import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
const before = ['Improvvisi ogni preventivo', 'Fai pagare senza sapere se guadagni', 'Gestisci i clienti senza processi', 'Perdi ore cercando documenti', 'Dimentichi di ricontattare i clienti', 'Regali garanzie', 'Ricominci ogni mese da zero'];
const after = ['Preventivi con un modello pronto', 'Prezzi calcolati sul profitto reale', 'Un processo chiaro per ogni cliente', 'Documenti tutti in un unico posto', 'Follow-up automatico su WhatsApp', 'Garanzie con condizioni blindate', 'Un flusso costante di richieste'];
export function Problem() {
  return <section className="border-b border-white/10 bg-ink-950" data-id="element-201" data-mp="23rrbbpuuv26q">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-5xl" data-id="element-202" data-mp="6yplpr1ybx0a">
        <div className="text-center" data-id="element-203" data-mp="1z35r9uqo2ns">
          <SectionLabel tone="danger" data-id="element-204" data-mp="204kppevl9as">Il vero problema</SectionLabel>
          <h2 className="mt-4 font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-205" data-mp="14bbqw28riosp">
            Il problema non è che non sai riparare.
            <span className="mt-2 block text-accent" data-id="element-206" data-mp="19829aw81hwha">
              È che lavori come un tecnico, quando potresti gestire un’attività.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-207" data-mp="10a9t7puhuksu">
            La maggior parte dei tecnici investe anni per imparare a riparare elettrodomestici, ma
            non impara mai come gestire l’attività che c’è dietro. Lavorano di più, si stancano di
            più, ma guadagnano meno di quanto dovrebbero.
          </p>
        </div>

        <div className="mt-9 grid gap-4 lg:grid-cols-2 lg:gap-6" data-id="element-208" data-mp="1j7azddzsaqyd">
          <div className="rounded-2xl border border-danger/25 bg-danger/[0.06] p-4 sm:p-6" data-id="element-209" data-mp="26y6vgnb9w8bf">
            <h3 className="font-display text-lg uppercase tracking-wide text-danger sm:text-xl" data-id="element-210" data-mp="2bond6jm4mg3l">
              Prima · senza sistema
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-211" data-mp="2ljawwpk04kf7">
              {before.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-212" data-mp="2gmkmoiuvoj1p">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-danger/20" data-id="element-213" data-mp="2bm6birxzcszg">
                    <XIcon className="h-3 w-3 text-danger" aria-hidden="true" data-id="element-214" data-mp="26o4vkfvup9s7" />
                  </span>
                  <span className="text-[14px] leading-snug text-white/70 sm:text-[15px]" data-id="element-215" data-mp="22mtamnnx9cqc">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-accent/30 bg-accent/[0.06] p-4 sm:p-6" data-id="element-216" data-mp="1swqb04map0j1">
            <h3 className="font-display text-lg uppercase tracking-wide text-accent sm:text-xl" data-id="element-217" data-mp="1nxwxic70d9iv">
              Dopo · con il sistema
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-218" data-mp="1ew5ph0ozwqlu">
              {after.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-219" data-mp="1eya2c84vgzy9">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/20" data-id="element-220" data-mp="3qir3oskn60un">
                    <CheckIcon className="h-3 w-3 text-accent" aria-hidden="true" data-id="element-221" data-mp="3ujb2e0kv5ciw" />
                  </span>
                  <span className="text-[14px] leading-snug text-white/80 sm:text-[15px]" data-id="element-222" data-mp="3cqbcgut64lv">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-7" data-id="element-223" data-mp="3bud20kyyoifo">
          <p className="text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-224" data-mp="3gtpo33i0dlh7">
            I clienti non possono sapere se sei il migliore a riparare una lavatrice. Ma notano, fin
            dal primo minuto, <strong className="font-semibold text-white" data-id="element-225" data-mp="2o51wkq6o1zv7">come fai il preventivo,
            come consegni un ordine di servizio, come spieghi una garanzia, come organizzi il tuo
            lavoro, come fai il follow-up e come trasmetti fiducia.</strong>
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-226" data-mp="yo6cevy3hm40">
            Il tecnico che sembra più professionale è quello che ottiene più raccomandazioni, più
            clienti ricorrenti e che giustifica meglio il valore del proprio servizio.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md lg:max-w-lg" data-id="element-227" data-mp="13lor72ysmvjx">
          <CtaButton label="Voglio smettere di improvvisare" data-id="element-228" data-mp="1ib4da5ndqcta" />
        </div>
      </div>
    </section>;
}